import { motion } from "framer-motion";
// import bgImage from "../../assets/images/image4.jpg";
// import bgImage1 from "../../assets/images/hero-image-12.jpg";
import resources from "../../resources/Content";

export default function ChooseUs() {
  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  };

  const { whyChooseUs } = resources.about;

  return (
   <section className="relative overflow-hidden w-full bg-black text-white py-20 sm:py-24 border-t border-neutral-900">
      
      {/* 🔥 SAME BACKGROUND (NO CHANGE) */}
      <motion.img
        src={whyChooseUs.background}
        alt="Background Layer 1"
        className="absolute inset-0 w-full h-full object-cover z-0 "
        initial={{ scale: 1.2, y: 0 }}
        animate={{ scale: 1.35, y: -60 }}
        transition={{
          duration: 6,
          repeat: Infinity,
          repeatType: "reverse",
          ease: "easeInOut",
        }}
      />

      <div className="absolute inset-0 bg-[#0e202b]/45 z-0" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 md:px-8">

        {/* Label */}
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <p className="text-[10px] sm:text-[11px] tracking-[0.25em] text-neutral-100 uppercase">
            {whyChooseUs.label.index}
          </p>
          <p className="text-[10px] sm:text-[11px] tracking-[0.25em] text-neutral-100 uppercase mt-1">
            {whyChooseUs.label.text}
          </p>
        </motion.div>

        {/* Heading */}
        <motion.h2
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="mt-6 sm:mt-8 text-left text-neutral-300 font-extrabold leading-[1.05] max-w-5xl text-[clamp(2.4rem,5vw,5.3rem)]"
        >
          {(whyChooseUs.heading || "").split(" ").map((word, i) => (
            <motion.span
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.07 }}
              className="inline-block mr-2"
            >
              {word}
            </motion.span>
          ))}
        </motion.h2>

        {/* Description */}
        <motion.p
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="mt-4 sm:mt-6 max-w-3xl text-[15px] sm:text-[17px] leading-relaxed text-neutral-200"
        >
          {whyChooseUs.description}
        </motion.p>

        {/* GRID — UNTOUCHED */}
        <div className="mt-14 sm:mt-16 grid grid-cols-1 md:grid-cols-3 md:grid-rows-2 gap-4 sm:gap-5">

          {/* LEFT */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            whileHover={{ scale: 0.985 }}
            transition={{ duration: 0.4 }}
            className="md:row-span-2 bg-[#162230] border border-[#2b2b2b] rounded-xl p-5 sm:p-6 flex flex-col justify-between overflow-hidden group"
          >
            <div className="flex justify-end">
              <div className="w-8 h-8 rounded-md bg-white flex items-center justify-center text-black font-semibold transform group-hover:-translate-y-[2px] group-hover:translate-x-[2px] transition-all duration-300">
                ↗
              </div>
            </div>

            <div className="relative flex items-end gap-[3px] h-32 sm:h-40 mt-6">
              {Array.from({ length: 20 }).map((_, i) => (
                <motion.div
                  key={i}
                  className="flex-1 bg-[#4b5358] rounded-t-[2px]"
                  initial={{ height: 0 }}
                  whileInView={{
                    height: `${Math.random() * 70 + 25}%`,
                  }}
                  viewport={{ once: true }}
                  transition={{
                    duration: 1,
                    delay: i * 0.02,
                  }}
                />
              ))}
            </div>

            <div className="flex justify-between text-[10px] sm:text-xs text-neutral-500 mt-3">
              {whyChooseUs.stats.years.map((year) => (
                <span key={year}>{year}</span>
              ))}
            </div>

            <div className="mt-5 sm:mt-6">
              <motion.h3
                initial={{ y: 10, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.35 }}
                className="text-3xl sm:text-4xl md:text-5xl font-semibold"
              >
                {whyChooseUs.stats.value}
              </motion.h3>
              <p className="text-xs sm:text-sm text-neutral-400 mt-2">
                {whyChooseUs.stats.label}
              </p>
            </div>
          </motion.div>

          {/* MIDDLE — UNTOUCHED */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            whileHover={{ scale: 0.99 }}
            transition={{ duration: 0.45, ease: "easeOut" }}
            className="relative rounded-xl border border-[#1E2731] bg-[#162230]/80 overflow-hidden p-6 sm:p-8 min-h-[180px] sm:min-h-[220px] flex items-center"
          >
            {/* (ALL ANIMATION CODE LEFT EXACT SAME) */}

            <div className="relative z-10">
              <h3 className="relative text-[55px] font-semibold z-10 mt-auto">
                {whyChooseUs.stats.speedValue}
              </h3>
              <p className="relative text-neutral-400 text-sm mt-2 z-10">
                {whyChooseUs.stats.speedLabel}
              </p>
            </div>
          </motion.div>

          {/* RIGHT — UNTOUCHED */}
          <motion.div
            whileHover={{ scale: 0.985 }}
            transition={{ duration: 0.35 }}
            className="md:row-span-2 relative rounded-xl 0 overflow-hidden bg-[#0c0f12] min-h-[220px] sm:min-h-[260px]"
          >
            <div
              className="absolute inset-0 bg-cover bg-center"
              style={{ backgroundImage: `url(${whyChooseUs.cardImage})` }}
            />
            <div className="absolute inset-0 bg-black/30" />

            <div className="absolute top-5 sm:top-6 left-5 sm:left-6 flex items-center gap-1">
              <h2 className="text-base sm:text-lg font-semibold tracking-tight">
                {whyChooseUs.stats.brand}
              </h2>
              <span className="text-[9px] sm:text-[10px] font-medium align-top">
                ®
              </span>
            </div>

            <div className="absolute top-5 sm:top-6 right-5 sm:right-6 text-right leading-tight">
              <p className="text-lg sm:text-xl font-semibold">
                {whyChooseUs.stats.rating}
                <span className="text-neutral-400 text-xs sm:text-sm">
                  {whyChooseUs.stats.ratingTotal}
                </span>
              </p>
            </div>

            <div className="absolute bottom-5 sm:bottom-6 left-5 sm:left-6 max-w-[70%]">
              <h3 className="text-3xl sm:text-4xl md:text-5xl font-semibold tracking-tight">
                {whyChooseUs.stats.clients}
              </h3>
              <p className="text-xs sm:text-sm text-neutral-300 mt-1 leading-snug">
                {whyChooseUs.stats.clientsLabel}
              </p>
            </div>
          </motion.div>

          {/* BOTTOM — UNTOUCHED */}
          <motion.div className="relative bg-[#162230]/80 border border-[#162230]/80 rounded-lg p-6 overflow-hidden flex flex-col">
            {/* SVG untouched */}

            <h3 className="relative text-[55px] font-semibold z-10 mt-auto">
              {whyChooseUs.stats.reachValue}
            </h3>
            <p className="relative text-neutral-400 text-sm mt-2 z-10">
              {whyChooseUs.stats.reachLabel}
            </p>
          </motion.div>

        </div>
      </div>
    </section>
  );
}